export default __webpack_public_path__ + "static/media/creditcard.52093b77.svg";